<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.file_types="{ value: v }">
      <template v-for="item in v">
        <v-chip :key="item" small class="pa-2 mr-1">
          {{ item }}
        </v-chip>
      </template>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Roadmaps/Directions/BaseEvents/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableBaseEvents',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
